import { ArgsType, Field } from '@nestjs/graphql'

@ArgsType()
export class AddNewEmailAddressDto {
  @Field()
  emailAddress!: string
}
